/* Letters & Lilacs: add to bag without leaving the page, and sticker tabs. */
(function () {
  function setBagCount(count) {
    document.querySelectorAll('[data-bcb-bag-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count < 1;
    });
    document.querySelectorAll('[data-bcb-bag-link]').forEach(function (el) {
      el.setAttribute('aria-label', 'Bag, ' + count + ' items');
    });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[data-bcb-add]');
    if (!form || !window.fetch) return;
    event.preventDefault();
    var button = form.querySelector('button');
    var label = button.querySelector('span');
    var original = label.textContent;
    button.disabled = true;
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return fetch('/cart.js', { headers: { Accept: 'application/json' } });
      })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        setBagCount(cart.item_count);
        label.textContent = 'Added ✓';
        setTimeout(function () { label.textContent = original; button.disabled = false; }, 2200);
      })
      .catch(function (err) {
        label.textContent = (err && err.description) || 'Try again';
        setTimeout(function () { label.textContent = original; button.disabled = false; }, 2600);
      });
  });

  document.addEventListener('click', function (event) {
    var tab = event.target.closest('[data-bcb-tab]');
    if (!tab) return;
    var root = tab.closest('[data-bcb-tabs]');
    root.querySelectorAll('[data-bcb-tab]').forEach(function (t) {
      t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
    });
    root.querySelectorAll('[data-bcb-panel]').forEach(function (p) {
      p.hidden = p.getAttribute('data-bcb-panel') !== tab.getAttribute('data-bcb-tab');
    });
  });
})();

/* Product recommendations load after the page, like Dawn's related products. */
(function () {
  function load() {
    document.querySelectorAll('[data-bcb-recs]').forEach(function (box) {
      if (box.children.length || !window.fetch) return;
      fetch(box.getAttribute('data-url'))
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-bcb-recs]');
          if (fresh && fresh.children.length) box.innerHTML = fresh.innerHTML;
        })
        .catch(function () {});
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', load);
  else load();
})();
